<div class="loading-screen-wrapper" *ngIf="loading">
  <!-- Animation loader -->
  <!-- <ng-lottie *ngIf="type === 'lottie'" containerClass="loadingAnimation" [options]="lottieoptions" ></ng-lottie> -->
  <!-- <img *ngIf="type === 'image'" src="../../../assets/images/logo.png" alt="" srcset="" class='loading-img'> -->
  <img src="../../../assets/images/logo.png" alt="" srcset="" class='loading-img'>
</div>
